import { render, staticRenderFns } from "./workerIdCardImg.vue?vue&type=template&id=c8d10dc0&scoped=true&"
import script from "./workerIdCardImg.vue?vue&type=script&lang=js&"
export * from "./workerIdCardImg.vue?vue&type=script&lang=js&"
import style0 from "./workerIdCardImg.vue?vue&type=style&index=0&id=c8d10dc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d10dc0",
  null
  
)

export default component.exports